import React from "react";

export default function CommonPopup({ title, message, onClose }) {
  return (
    <>
      <link rel="stylesheet" href="/css/popup.css" />
      <div className="popup-overlay">
        <div className="popup-box" onClick={(e) => e.stopPropagation()}>
          <h3 className="popup-title">{title}</h3>
          <p className="popup-message">{message}</p>

          <div className="popup-actions">
            <button className="popup-button" onClick={onClose} >
              OK
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
